import { render, staticRenderFns } from "./Sockets.vue?vue&type=template&id=04c0ab65&scoped=true&"
import script from "./Sockets.vue?vue&type=script&lang=js&"
export * from "./Sockets.vue?vue&type=script&lang=js&"
import style0 from "./Sockets.vue?vue&type=style&index=0&id=04c0ab65&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c0ab65",
  null
  
)

export default component.exports